import React, { FC } from 'react'
import { Modal, Button } from 'antd'
import { ModalProps } from 'antd/lib/modal'
import { submit } from 'redux-form'
import { useDispatch } from 'react-redux'

// components
import GeneralFormAttributesForm from '../forms/GeneralFormAttributesForm'

// utils
import { FORM } from '../../utils/enums'

// assets
import { ReactComponent as CloseIcon } from '../../assets/icons/BaseIcons/x-icon.svg'

type Props = ModalProps & {
	isVisible: boolean
	title: string
	onCancel: any
	onConfirmBtnTitle: string
	handleSubmit: any
	disabled?: boolean
	classNameBtn?: string
}

const FormSettingsModal: FC<Props> = (props) => {
	const { isVisible, title, onCancel, width, onConfirmBtnTitle, cancelText, classNameBtn, handleSubmit, disabled } = props

	const dispatch: any = useDispatch()

	return (
		<Modal
			closeIcon={<CloseIcon width={18} height={18} />}
			title={title}
			centered
			open={isVisible}
			width={width}
			onCancel={onCancel}
			footer={[
				<Button disabled={disabled || false} style={{ width: 124, height: 40 }} key='back' type='text' onClick={onCancel}>
					{cancelText}
				</Button>,
				<Button
					style={{ width: 124, height: 40 }}
					disabled={disabled || false}
					className={classNameBtn}
					key='submit'
					type='primary'
					onClick={() => dispatch(submit(FORM.GENERALE_TEMPLATE_ATTRIBUTES))}
				>
					{onConfirmBtnTitle}
				</Button>
			]}
		>
			<GeneralFormAttributesForm onSubmit={handleSubmit} />
		</Modal>
	)
}

export default FormSettingsModal
